import React, { useState, useRef } from "react";
import axios from "axios";
import ReactAudioPlayer from "react-audio-player";
import "./Results.css";

let apiKey = process.env.REACT_APP_DICTIONARY_KEY;

export default function Results(props) {
  let [results, setResults] = useState(null);
  let audioPlayerRef = useRef();

  function handleResponse(response) {
    if (!response.data.word) {
      setResults({ notFound: true });
    } else {
      setResults(response.data);
    }
  }

  function handleError() {
    setResults({ notFound: true });
  }

  function handlePlayClick() {
    audioPlayerRef.current.audioEl.current.play();
  }

  if (results) {
    if (results.notFound) {
      return (
        <div className="Results-card">
          <p>Nessun risultato trovato per "{props.keyword}".</p>
        </div>
      );
    }

    let audioUrl = `https://ssl.gstatic.com/dictionary/static/sounds/oxford/${results.word.toLowerCase()}--_us_1.mp3`;

    return (
      <div className="Results">
        <div className="Results-card Results-word-card">
          <div className="Results-word-row">
            <h2 className="Results-word">{results.word}</h2>
            <button
              type="button"
              className="Results-play-button"
              onClick={handlePlayClick}
              aria-label={`Ascolta la pronuncia di ${results.word}`}
            >
              🔊
            </button>
          </div>
          {results.phonetic && (
            <p className="Results-phonetic">{results.phonetic}</p>
          )}
          <ReactAudioPlayer
            src={audioUrl}
            ref={audioPlayerRef}
            controls={false}
            className="Results-audio"
          />
        </div>

        {results.meanings.map((meaning, index) => (
          <div className="Results-card" key={index}>
            <h3 className="Results-partOfSpeech">{meaning.partOfSpeech}</h3>
            <p className="Results-definition">{meaning.definition}</p>
            {meaning.example && (
              <p className="Results-example">"{meaning.example}"</p>
            )}
            {meaning.synonyms && meaning.synonyms.length > 0 && (
              <p className="Results-synonyms">
                <span className="Results-synonyms-label">Simili: </span>
                {meaning.synonyms.join(", ")}
              </p>
            )}
          </div>
        ))}
      </div>
    );
  } else {
    let url = `https://api.shecodes.io/dictionary/v1/define?word=${props.keyword}&key=${apiKey}`;
    axios.get(url).then(handleResponse).catch(handleError);
    return <p className="Results-loading">Caricamento...</p>;
  }
}
